import { registerPlugin } from '@capacitor/core';

interface PayPalNativeCheckoutAuthPlugin {
  startCheckoutAuth(option: { url: string }): Promise<any>;
}

export const payPalNativeCheckoutAuthPlugin =
  registerPlugin<PayPalNativeCheckoutAuthPlugin>('PayPalCheckoutAuth');
